// pages/CreateLooseStone.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import LooseStoneForm from "../components/looseStone/LooseStoneForm";
import { useGetAllStonesQuery } from "../toolkitServices/stoneApi";
import { setStoneList } from "../slices/stoneSlice";
import { useDispatch } from "react-redux";
import { useGetAllBranchesQuery } from "../toolkitServices/branchApi";
import { useGetAllVendorsQuery } from "../toolkitServices/vendorApi";
import { setVendorList } from "../slices/vendorSlice";
import { setBranchList } from "../slices/branchSlice";
import { useGetStoneAttributesQuery } from "../toolkitServices/stoneAttributeApi";
import { setStoneAttrList } from "../slices/stoneAttrSlice";
import { useGetCountersQuery } from "../toolkitServices/counterApi";
import { setCounterList } from "../slices/counterSlice";

const CreateLooseStone = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { data: stones } = useGetAllStonesQuery();
  const { data: branches } = useGetAllBranchesQuery();
  const { data: counters } = useGetCountersQuery();
  const { data: vendors } = useGetAllVendorsQuery({
    page: 1,
    limit: 10,
    search: "",
  });
  const {
    data: stnAttr,
    isFetching,
    isError,
    error,
  } = useGetStoneAttributesQuery({}, { refetchOnMountOrArgChange: true });
  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && e.key === "Backspace") {
        e.preventDefault();
        navigate(-1);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);

  useEffect(() => {
    if (vendors?.data?.length) dispatch(setVendorList(vendors.data));
    if (stones?.data?.length) dispatch(setStoneList(stones.data));
    if (branches?.data?.length) dispatch(setBranchList(branches.data));
    if (stnAttr?.data?.length) dispatch(setStoneAttrList(stnAttr?.data));
    if (counters?.data?.length) dispatch(setCounterList(counters?.data));
  }, [vendors, branches,counters, stones, stnAttr, dispatch]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="max-w-8xl mx-auto"
    >
      <div className="bg-white shadow-lg rounded-2xl border p-2">
        <LooseStoneForm />
      </div>
    </motion.div>
  );
};

export default CreateLooseStone;
